import { jsx as _jsx } from "react/jsx-runtime";
import * as Components from '_components';
import { Frame, FrameComponent } from './Frame';
import { FrameSegment } from './Segments';
import * as Types from './Types';
export function FrameRender(component, index) {
    return (_jsx(Frame, { children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
export function frameComponentRegister(type) {
    switch (type) {
        case 'side':
            return RenderFrameSide;
        case 'content':
            return RenderFrameContent;
        case 'segment':
            return RenderFrameSegment;
    }
}
export function RenderFrameSide(component, index) {
    function mapType(type) {
        switch (type) {
            case 'none':
                return Types.FrameSideType.None;
            case 'small':
                return Types.FrameSideType.Small;
            case 'big':
                return Types.FrameSideType.Big;
            default:
                return Types.FrameSideType.None;
        }
    }
    function mapSide(side) {
        switch (side) {
            case 'left':
                return Types.FrameComponentType.Left;
            case 'right':
                return Types.FrameComponentType.Right;
            case 'top':
                return Types.FrameComponentType.Top;
            case 'bottom':
                return Types.FrameComponentType.Bottom;
            default:
                return Types.FrameComponentType.Content;
        }
    }
    return (_jsx(FrameComponent, { type: mapType(component.properties.type), side: mapSide(component.properties.side), children: component.children
            ?.filter(child => child.type.toLowerCase() === 'frame_segment')
            .map((child, index) => {
            return RenderFrameSegment(child, index);
        }) }, index));
}
export function RenderFrameContent(component, index) {
    return (_jsx(FrameComponent, { side: Types.FrameComponentType.Content, children: _jsx(Components.SimpleComponentContent, { component: component }) }));
}
export function RenderFrameSegment(component, index) {
    function mapType(type) {
        switch (type) {
            case 'gap':
                return Types.FrameSegmentType.Gap;
            case 'empty':
                return Types.FrameSegmentType.Empty;
            case 'simple':
                return Types.FrameSegmentType.Simple;
            case 'complex':
                return Types.FrameSegmentType.Complex;
            default:
                return Types.FrameSegmentType.Empty;
        }
    }
    return (_jsx(FrameSegment, { type: mapType(component.properties.type), children: _jsx(Components.SimpleComponentContent, { component: component }) }, index));
}
